jQuery(document).ready(function ($) {


  window.dataLayer = window.dataLayer || [];
  // Get the URL parameter from the main page
  const urlParams = new URLSearchParams(window.location.search);
  const popped = urlParams.get('p');

  // Define Data Storage
  const BuilderStorage = {
    // Add a new property to track initialization state
    _freshInit: true,

    set: function (key, value) {
      const storageKey = key.startsWith('ppc-') ? key : `ppc-${key}`;
      localStorage.setItem(storageKey, JSON.stringify(value));
      this._freshInit = false;
    },

    get: function (key) {
      const storageKey = key.startsWith('ppc-') ? key : `ppc-${key}`;
      const item = localStorage.getItem(storageKey);
      if (item !== null) {
        this._freshInit = false;
      }
      return item ? JSON.parse(item) : null;
    },

    init: function () {
      // Check if storage is empty before initialization
      const isEmpty = !localStorage.getItem('ppc-currentStep') &&
        !localStorage.getItem('ppc-siteEmulated') &&
        !localStorage.getItem('ppc-industry') &&
        !localStorage.getItem('ppc-industryDescription') &&
        !localStorage.getItem('ppc-description') &&
        !localStorage.getItem('ppc-topics') &&
        !localStorage.getItem('ppc-selectedTopics') &&
        !localStorage.getItem('ppc-suggestedDomains') &&
        !localStorage.getItem('ppc-domainTldData') &&
        !localStorage.getItem('ppc-desiredLength') &&
        !localStorage.getItem('ppc-preferredLanguage') &&
        !localStorage.getItem('ppc-categoryKey');

      // Initialize with default values if not set
      if (!this.get('ppc-currentStep')) this.set('ppc-currentStep', 1);
      if (!this.get('ppc-siteEmulated')) this.set('ppc-siteEmulated', '');
      if (!this.get('ppc-industry')) this.set('ppc-industry', '');
      if (!this.get('ppc-industryDescription')) this.set('ppc-industryDescription', '');
      if (!this.get('ppc-description')) this.set('ppc-description', '');
      if (!this.get('ppc-topics')) this.set('ppc-topics', []);
      if (!this.get('ppc-selectedTopics')) this.set('ppc-selectedTopics', []);
      if (!this.get('ppc-suggestedDomains')) this.set('ppc-suggestedDomains', []);
      if (!this.get('ppc-domainTldData')) this.set('ppc-domainTldData', {});
      if (!this.get('ppc-desiredLength')) this.set('ppc-desiredLength', 10);
      if (!this.get('ppc-preferredLanguage')) this.set('ppc-preferredLanguage', 'English');
      if (!this.get('ppc-categoryKey')) this.set('ppc-categoryKey', '');

      // Set _freshInit based on whether storage was empty before initialization
      this._freshInit = isEmpty;
    },

    isFreshInit: function () {
      return this._freshInit;
    },

    reset: function () {
      // Reset all values to their defaults without clearing localStorage
      this.set('ppc-currentStep', 1);
      this.set('ppc-siteEmulated', '');
      this.set('ppc-industry', '');
      this.set('ppc-industryDescription', '');
      this.set('ppc-description', '');
      this.set('ppc-topics', []);
      this.set('ppc-selectedTopics', []);
      this.set('ppc-suggestedDomains', []);
      this.set('ppc-domainTldData', {});
      this.set('ppc-desiredLength', 10);
      this.set('ppc-preferredLanguage', 'English');
      this.set('ppc-categoryKey', '');

      // Reset is an active operation, so it's no longer a fresh init
      this._freshInit = false;
    },

    clear: function () {
      const keys = [
        'currentStep',
        'siteEmulated',
        'industry',
        'industryDescription',
        'description',
        'topics',
        'selectedTopics',
        'suggestedDomains',
        'domainTldData',
        'desiredLength',
        'preferredLanguage',
        'categoryKey'
      ];

      keys.forEach(key => {
        localStorage.removeItem(`ppc-${key}`);
      });

      this.init();
    }
  };

  const generateDomainIdeas = async function (params) {
    const {
      industry,
      selectedTopics,
      description,
      nameLength,
      language,
      onSuccess,
      onError,
      onComplete
    } = params;

    try {
      const token = await RecaptchaHelper.execute('generate_domains');

      $('#domain-ideas-container').html(`
        <div class="row align-items-center">
            <div class="col-12 col-md-8 mt-3 mx-auto">
                <div class="card card-flush mb-15">
                    <div class="card-body text-center d-flex flex-column align-items-center justify-content-center">
                        <span class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </span>
                        <span class="card-label fw-bold text-gray-900 mt-7" style="font-size: 1.275rem;">
                            Loading new domains...
                        </span>
                    </div>
                </div>
            </div>
        </div>
    `);

      AnalyticsHelper.trackBizTopicsSelected(selectedTopics);

      return new Promise((resolve, reject) => {
        $.ajax({
          url: craftrtech_ajax.ajax_url,
          type: 'POST',
          data: {
            action: 'craftrtech_ppc_domain_ideas',
            industry,
            selected_topics: selectedTopics,
            description,
            name_length: nameLength,
            language,
            recaptcha_token: token,
            _ajax_nonce: craftrtech_ajax.nonce
          },
          success: function (response) {
            if (response.success) {
              // Store new domain ideas and clear previous TLD data
              BuilderStorage.set('ppc-suggestedDomains', response.data.domain_ideas);
              BuilderStorage.set('ppc-domainTldData', {});

              // Re-render domains with new data
              const domainsHtml = response.data.domain_ideas.map((domainData, index) =>
                DomainCardHelper.generateCard(domainData, index + 1)
              ).join('');

              $('#domain-ideas-container').html(domainsHtml);

              if (onSuccess) {
                onSuccess(response.data);
              }
              resolve(response.data);
            } else {
              ErrorHandler.log('PPC Step 2', response?.data?.message || 'Failed to generate domains');
              $('#domain-ideas-container').html('<p class="text-danger">Failed to generate domains. Please try again.</p>');
              showErrorPopupReset(response?.data?.message || 'Failed to generate domains');

              if (onError) {
                onError(response?.data?.message || 'Failed to generate domains');
              }
              reject(new Error(response?.data?.message || 'Failed to generate domains'));
            }
          },
          error: function (xhr, status, error) {
            ErrorHandler.log('PPC Step 2', error, {
              status,
              xhr: xhr.responseText
            });

            $('#domain-ideas-container').html(UIHelper.generateErrorMessage());
            showErrorPopupReset('An error occurred while generating domains. Please try again.');

            if (onError) {
              onError(error);
            }
            reject(error);
          },
          complete: function () {
            if (onComplete) {
              onComplete();
            }
          }
        });
      });
    } catch (error) {
      ErrorHandler.log('Step 4', error);
      $('#domain-ideas-container').html('<p class="text-danger">An error occurred. Please try again.</p>');
      showErrorPopup('An error occurred while processing your request. Please try again.');

      if (onError) {
        onError(error);
      }
      throw error;
    }
  };

  const getBusinessTags = async function (params) {
    const {
      businessDescription,
      industry,
      onSuccess,
      onError,
      onComplete
    } = params;

    try {
      const token = await RecaptchaHelper.execute('get_tags');

      return new Promise((resolve, reject) => {
        $.ajax({
          url: craftrtech_ajax.ajax_url,
          type: 'POST',
          data: {
            action: 'craftrtech_ppc_get_tags',
            business_description: businessDescription,
            industry: industry,
            recaptcha_token: token,
            _ajax_nonce: craftrtech_ajax.nonce
          },
          success: function (response) {
            if (response.success) {
              // Store topics in localStorage
              const topicsArray = response.data.topics.split(',').map(topic => topic.trim());
              BuilderStorage.set('ppc-topics', topicsArray);

              // Get current selected topics and filter out ones not in new topics array
              const currentSelectedTopics = BuilderStorage.get('ppc-selectedTopics') || [];
              const filteredSelectedTopics = currentSelectedTopics.filter(topic =>
                topicsArray.includes(topic)
              );
              BuilderStorage.set('ppc-selectedTopics', filteredSelectedTopics);

              // Display topics with appropriate classes for selected ones
              const topicsHtml = topicsArray.map(topic => {
                const isSelected = filteredSelectedTopics.includes(topic);
                return `<span class="btn me-5 mb-5 btn-sm topic ${isSelected ? 'btn-success selected' : 'btn-secondary'}" data-topic="${topic}">${topic}<i class="ki-duotone ki-double-check fs-4 ms-1 me-0">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i></span>`;
              }).join('');

              $('#topics-container').html(topicsHtml);

              if (onSuccess) {
                onSuccess(response.data);
              }
              resolve(response.data);
            } else {
              ErrorHandler.log('PPC Step 2', response?.data?.message || 'Failed to generate topics', {
                industry,
                description: businessDescription
              });
              $('#topics-container').html(UIHelper.generateErrorMessage('Failed to generate topics. Please try to improve your business description and try again.'));
              showErrorPopupReset(response?.data?.message || 'Failed to generate topics. Please try again.');

              if (onError) {
                onError(response?.data?.message || 'Failed to generate topics');
              }
              reject(new Error(response?.data?.message || 'Failed to generate topics'));
            }
          },
          error: function (xhr, status, error) {
            ErrorHandler.log('PPC Step 2', error, {
              industry,
              description: businessDescription,
              status,
              xhr: xhr.responseText
            });
            $('#topics-container').html(UIHelper.generateErrorMessage());
            showErrorPopupReset('An error occurred while generating topics. Please try again.');

            if (onError) {
              onError(error);
            }
            reject(error);
          },
          complete: function () {
            if (onComplete) {
              onComplete();
            }
          }
        });
      });
    } catch (error) {
      ErrorHandler.log('PPC Step 2', error);
      $('#topics-container').html(UIHelper.generateErrorMessage());
      showErrorPopup('An error occurred while processing your request. Please try again.');

      if (onError) {
        onError(error);
      }
      throw error;
    }
  };

  // Error Handler Object
  const ErrorHandler = {
    log: function (step, error, context = {}) {
      AnalyticsHelper.trackError(error, step, context);

      console.log('=== Builder Error ===');
      console.log('Step:', step);
      console.log('Error:', error);
      console.log('Context:', context);
      console.log('==================');
    }
  };

  // Add this after BuilderStorage definition
  const RecaptchaHelper = {
    execute: async function (action) {
      try {
        console.log('RecaptchaHelper: Starting execution for action:', action);

        // Check if reCAPTCHA is enabled
        if (!craftrtech_recaptcha?.enabled) {
          console.log('RecaptchaHelper: reCAPTCHA is disabled, skipping verification');
          return 'disabled';
        }

        // Wait for grecaptcha to be ready
        await new Promise((resolve) => {
          if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.execute !== 'undefined') {
            resolve();
          } else {
            grecaptcha.ready(resolve);
          }
        });

        // Use site key from WordPress
        const token = await grecaptcha.execute(craftrtech_recaptcha.site_key, { action: action });
        console.log('RecaptchaHelper: Token generated successfully for', action);

        if (!token) {
          throw new Error('No token received from reCAPTCHA');
        }

        return token;
      } catch (error) {
        console.error('RecaptchaHelper error:', error);
        throw error;
      }
    }
  };

  const updateStepContent = async (newContent) => {
    const $content = $('#step-content');

    // Add transition class
    $content.addClass('content-transitioning');

    // Wait for fade out
    await new Promise(resolve => setTimeout(resolve, 300));

    // Update content
    $content.html(newContent);

    // Force browser reflow
    $content[0].offsetHeight;

    // Remove transition class to fade in
    $content.removeClass('content-transitioning');
  };

  // Move the changeStep function definition before any usage
  const changeMainContent = async function (step) {
    try {
      // Show loading
      await updateStepContent(`
            <div class="row align-items-center">
                <div class="col-12 col-md-8 mx-auto">
                    <div class="card card-flush mb-15">
                        <div class="card-body text-center d-flex flex-column align-items-center justify-content-center">
                            <span class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </span>
                            <span class="card-label fw-bold text-gray-900 mt-7" style="font-size: 1.275rem;">
                                Kickstarting some magic...
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        `);

      // Fetch the new step content
      const response = await $.ajax({
        url: craftrtech_ajax.ajax_url,
        type: 'POST',
        data: {
          action: 'ppc_load_builder_step',
          step: step,
          popped: popped,
          page_id: craftrtech_ajax.page_id,
          _ajax_nonce: craftrtech_ajax.nonce
        }
      });

      if (response.success) {
        // Show new content with fade
        await updateStepContent(response.data.html);


        if (step == 1) {
          $('#business-input').val(BuilderStorage.get('ppc-description'));
        } else if (step == 2) {
          // Get saved data

          const suggestedDomains = BuilderStorage.get('ppc-suggestedDomains');
          const domainTldData = BuilderStorage.get('ppc-domainTldData');
          const description = BuilderStorage.get('ppc-description');
          const topics = BuilderStorage.get('ppc-topics') || [];
          const selectedTopics = BuilderStorage.get('ppc-selectedTopics') || [];
          const savedLength = BuilderStorage.get('ppc-desiredLength');
          const savedLanguage = BuilderStorage.get('ppc-preferredLanguage');

          // Populate the form with saved data
          $('#business-description').val(description);

          // Set saved length if it exists
          if (savedLength) {
            const parsedLength = parseInt(savedLength);
            const parsedLengthLessOne = parsedLength - 1;
            const parsedLengthPlusOne = parsedLength + 1;
            $('#name-length').val(parsedLength);
            const lengthRange = (parsedLengthLessOne) + "-" + (parsedLengthPlusOne);
            $('#name-length-value').text(lengthRange);
          }

          // Set saved language if it exists
          if (savedLanguage) {
            $('#language').val(savedLanguage);
          }

          // Generate topics HTML using the same badge style as step-3
          const topicsHtml = topics.map(topic => {
            const isSelected = selectedTopics.includes(topic);
            return `<span class="btn me-5 mb-5 btn-sm topic ${isSelected ? 'btn-success selected' : 'btn-secondary'}" 
                                         data-topic="${topic}">${topic} <i class="ki-duotone ki-double-check fs-4 ms-1 me-0 ">
<span class="path1"></span>
<span class="path2"></span>
</i></span>`;
          }).join('');
          $('#topics-container').html(topicsHtml);

          // Generate domains if we have the required data
          if (description) {
            await generateDomainIdeas({
              industry: BuilderStorage.get('ppc-industry') || 'general',
              selectedTopics,
              description,
              nameLength: savedLength,
              language: savedLanguage,
              onComplete: () => {
                const container = $('#step-content')[0];
                const header = $('#kt_app_header');
                const offset = header.length ? header.outerHeight() + 20 : 120; // Use header height + 20px if available, otherwise 120px
                const containerPosition = container.getBoundingClientRect().top;
                const offsetPosition = containerPosition + window.pageYOffset - offset;

                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });
              }
            });

            // Add getBusinessTags call
            await getBusinessTags({
              businessDescription: description,
              industry: BuilderStorage.get('ppc-industry') || 'general',
              onSuccess: (data) => {
                // Topics are already being displayed in the UI from the success handler
                console.log('Business tags generated successfully');
              },
              onError: (error) => {
                console.error('Error generating business tags:', error);
              },
              onComplete: () => {
                // Any cleanup or final actions can go here
              }
            });
          }
        }
      } else {
        throw new Error(response.data.message || 'Failed to load step');
      }
    } catch (error) {
      console.error('Error changing step:', error);
      $('#step-content').html(UIHelper.generateErrorMessage('An error occurred while loading the step. Please try again.'));
    }
  };

  if (BuilderStorage.get('ppc-description')?.trim()?.length > 0) {
    changeMainContent(2);
  }

  // Initialize storage on page load
  BuilderStorage.init();

  // Handle business description submission and get topics
  $(document).on('click', '#save-description', async function (e) {
    BuilderStorage.reset();

    // Get and validate business description
    const businessDescription = sanitizeInput($('#business-input').val());
    const industry = 'general';
    BuilderStorage.set('ppc-description', businessDescription);

    if (!businessDescription) {
      e.preventDefault();
      ErrorHandler.log('PPC Step 1', 'Empty description', { industry });
      showErrorPopup('Please enter a business description.');
      return;
    }

    // Add character limit validation
    if (businessDescription.length > 300) {
      e.preventDefault();
      ErrorHandler.log('PPC Step 1', 'Description too long', {
        industry,
        length: businessDescription.length
      });
      showErrorPopup('Business description must be 300 characters or less.');
      return;
    }

    AnalyticsHelper.trackBizDescConfirm();


    if (!hasPopunderCookie() && !popped) {
      setPopunderCookie();

      // Push analytics data
      AnalyticsHelper.trackNameOBCPop();

      let finalUrl = craftrtech_ajax.domain_builder.redirect_url || 'https://www.namecheap.com';
      try {
        const adParams = JSON.parse(localStorage.getItem('ad_parameters'));
        if (adParams?.gclid) {
          // Add gclid to URL, handling both cases where URL might already have parameters
          finalUrl += (finalUrl.includes('?') ? '&' : '?') + `gclid=${adParams.gclid}`;
        }
      } catch (error) {
        console.error('Error getting gclid:', error);
      }

      // Don't prevent default - let the link open in new tab
      // Then redirect current window to popunder URL
      setTimeout(() => {
        window.open(finalUrl, '_self');
      }, 250);
    } else {
      e.preventDefault();
      changeMainContent(2);
    }
  });

  // Handle name length range input
  $(document).on('input', '#name-length', async function () {
    const lengthRange = (parseInt(this.value) - 1) + "-" + (parseInt(this.value) + 1);
    $('#name-length-value').text(lengthRange);
  });

  // Handle regenerate button click
  $(document).on('click', '#regenerate-domains', async function () {
    try {
      $(this).prop('disabled', true);
      $(this).text('Processing...');

      const newSelectedTopics = BuilderStorage.get('ppc-selectedTopics');
      const nameLength = $('#name-length').val();
      const language = $('#language').val();
      BuilderStorage.set('ppc-desiredLength', nameLength);
      BuilderStorage.set('ppc-preferredLanguage', language);
      const industry = BuilderStorage.get('ppc-industry') || 'general';
      const description = BuilderStorage.get('ppc-description');

      AnalyticsHelper.trackRefineBizUrls();

      await generateDomainIdeas({
        industry,
        selectedTopics: newSelectedTopics,
        description,
        nameLength,
        language,
        onComplete: () => {
          $('#regenerate-domains').prop('disabled', false).text('Refine');
          $('#closeFilters').trigger('click');
          const container = $('#step-content')[0];
          const header = $('#kt_app_header');
          const offset = header.length ? header.outerHeight() + 20 : 120; // Use header height + 20px if available, otherwise 120px
          const containerPosition = container.getBoundingClientRect().top;
          const offsetPosition = containerPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    } catch (error) {
      $(this).prop('disabled', false).text('Refine');
    }
  });

  // Handle topic selection
  $(document).on('click', '.topic', function () {
    $(this).toggleClass('btn-secondary');
    $(this).toggleClass('btn-success');
    $(this).toggleClass('selected');

    // Get all selected topics
    const selectedTopics = $('.topic.selected').map(function () {
      return $(this).data('topic');
    }).get();

    // Store selected topics
    BuilderStorage.set('selectedTopics', selectedTopics);
  });

  // Handle clear storage button click
  $(document).on('click', '#clear-local-storage', function () {
    BuilderStorage.clear();
  });

  $(document).on('click', '#toggleFilters', function () {
    $('.mobile-filters').addClass('show');
  });

  $(document).on('click', '#closeFilters, #go-back, #go-back-edit-description', function () {
    $('.mobile-filters').removeClass('show');
  });

  $(document).on('click', '#go-back-edit-description', function (e) {
    e.preventDefault(); // Prevent form submission
    AnalyticsHelper.trackRefineBizUrls();
    changeMainContent(1);
  });

  $(document).on('click', '#go-back', function (e) {
    e.preventDefault(); // Prevent form submission
    AnalyticsHelper.trackRefineBizUrls();
    changeMainContent(1);
  });

  // Add event listener for business-input changes
  $(document).on('input', '#business-input', function () {
    const currentDescription = sanitizeInput($(this).val());
    BuilderStorage.set('ppc-description', currentDescription);
  });



  function showErrorPopup(message) {
    Swal.fire({
      title: 'Error',
      text: message,
      icon: 'error',
      buttonsStyling: false,
      confirmButtonText: "Ok, got it!",
      heightAuto: false,
      customClass: {
        confirmButton: "btn btn-light",
        container: 'swal-mobile-fix'
      }
    });
  }

  function showErrorPopupReset(message) {
    Swal.fire({
      title: 'Error',
      text: message,
      icon: 'error',
      buttonsStyling: false,
      confirmButtonText: "Start over!",
      heightAuto: false,
      customClass: {
        confirmButton: "btn btn-light",
        container: 'swal-mobile-fix'
      },
      willClose: () => {
        changeMainContent(1);
      },
      didClose: () => {
        changeMainContent(1);
      }
    });
  }

  // UI Helper Object
  const UIHelper = {
    generateErrorMessage: function (message = 'An error occurred. Please try again.') {
      return `
              <div class="col-12">
                  <div class="d-flex align-items-center rounded py-5 px-5 bg-light-danger">
                      <i class="ki-duotone ki-shield-cross fs-3x text-danger me-5">
                          <span class="path1"></span>
                          <span class="path2"></span>
                          <span class="path3"></span>
                      </i>
                      <div class="text-gray-700 fw-bold fs-6">
                          ${message}
                      </div>
                  </div>
              </div>
          `;
    }
  };

  // Domain HTML Helper
  const DomainCardHelper = {
    generateCard: function (domainData, index) {
      return `
              <div class="col-12 col-lg-4 domain-card">
                  <div class="card card-flush" data-domain="${domainData}">
                      <!--begin::Header-->
                      <div class="card-header pt-5">
                          <!--begin::Title-->
                          <h3 class="card-title text-gray-800 fw-bold">${domainData}</h3>
                          <!--end::Title-->
                      </div>
                      <!--end::Header-->

                      <!--begin::Body-->
                      <div class="card-body pt-5" data-domain-outer-index="${index}">
                          ${this.generateDomainLink(domainData, 'au', 1)}
                          <div class="separator separator-dashed my-3"></div>
                          ${this.generateDomainLink(domainData, 'com.au', 2)}
                          <div class="separator separator-dashed my-3"></div>
                          ${this.generateDomainLink(domainData, 'com', 3)}
                          <div class="separator separator-dashed my-3"></div>
                          ${this.generateDomainLink(domainData, 'org', 4)}
                          <div class="separator separator-dashed my-3"></div>
                          ${this.generateDomainLink(domainData, 'ai', 5)}
                          <div class="separator separator-dashed my-3"></div>
                          ${this.generateDomainLink(domainData, 'online', 6)}
                      </div>
                      <!--end::Body-->
                  </div>
              </div>
          `;
    },

    generateDomainLink: function (domain, tld, index) {
      const redirectSearchUrl = craftrtech_ajax.domain_builder.search_redirect_url || 'https://www.crazydomains.com.au/domain-names/search/?domain={domain}&promo[]=VJBB1CN2&promo[]=PNLPMKJS';
      const fullDomain = `${domain}.${tld}`.toLowerCase();
      let finalUrl = redirectSearchUrl.replace('{domain}', fullDomain);

      // Get gclid from localStorage if available
      try {
        const adParams = JSON.parse(localStorage.getItem('ad_parameters'));
        if (adParams?.gclid) {
          // Add gclid to URL, handling both cases where URL might already have parameters
          finalUrl += (finalUrl.includes('?') ? '&' : '?') + `gclid=${adParams.gclid}`;
        }
      } catch (error) {
        console.error('Error getting gclid:', error);
      }

      return `
              <!--begin::Item-->
              <div class="d-flex flex-stack">
                  <!--begin::Section-->
                  <a href="${finalUrl}" rel="nofollow" target="_blank" data-domain-index="${index}"
                     class="text-primary fw-semibold fs-6 me-2 d-flex flex-row w-100 outbound-link">
                     <i class="ki-duotone ki-check-square fs-2 text-success me-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      </i>
                      ${fullDomain}
                      <i class="ki-duotone ki-exit-right-corner fs-2 ms-auto">
                          <span class="path1"></span>
                          <span class="path2"></span>
                      </i>
                  </a>
                  <!--end::Section-->
              </div>
              <!--end::Item-->
          `;
    }
  };

  // Make sure Swal is available globally
  window.Swal = Swal;

  // Initialize SweetAlert2 with mobile-friendly defaults
  window.Toast = Swal.mixin({
    target: 'body',
    customClass: {
      container: 'position-fixed'
    },
    toast: true,
    position: 'bottom',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true
  });

  // Add iOS cursor fix
  if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
    document.body.style.cursor = 'pointer';
  }

  // Add this method near other helper objects/methods
  const AnalyticsHelper = {
    trackBusinessTypeSelection: function () {
      window.dataLayer.push({
        event: "Biz_Type_Selected",
        session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
        click_id: "NA",
        compete_input_url: BuilderStorage.get('siteEmulated'),
        biz_type: BuilderStorage.get('industry')
      });
    },
    trackError: function (errorMessage, step, context) {
      window.dataLayer.push({
        event: "tracked_error",
        session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
        tracked_error_message: errorMessage,
        tracked_error_step: step,
        tracked_error_context: JSON.stringify(context),
        tracked_error_url: window.location.href
      });
    },
    trackOutboundClick: function (outboundUrl, domainIndex, domainOuterIndex, domain) {
      try {
        const sessionId = JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '';
        const siteUrl = BuilderStorage.get('siteEmulated') || 'NA';
        const bizType = BuilderStorage.get('industry') || 'NA';
        const bizDesc = BuilderStorage.get('description') || 'NA';
        const selectedTopics = BuilderStorage.get('selectedTopics') || [];
        const allTopics = BuilderStorage.get('topics') || [];
        const wordLength = BuilderStorage.get('desiredLength') || 'NA';
        const urlLanguage = BuilderStorage.get('preferredLanguage') || 'NA';

        const nonSelectedTopics = allTopics.filter(topic => !selectedTopics.includes(topic));

        window.dataLayer.push({
          event: "Obclick_URL_Select",
          session_id: sessionId,
          click_id: "NA",
          compete_input_url: siteUrl,
          biz_type: bizType,
          biz_desc: bizDesc,
          select_topics: selectedTopics.join(','),
          non_select_topics: nonSelectedTopics.join(','),
          word_length: wordLength,
          url_language: urlLanguage,
          obclick_url_select: outboundUrl,
          domain: domain,
          tld_index: domainIndex,
          suggestion_index: domainOuterIndex
        });

      } catch (error) {
        console.error('Analytics Error:', error);
      }
    },
    trackRefineBizUrls: function () {
      window.dataLayer.push({
        event: "Refine_biz_urls",
        session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
        click_id: "NA",
        compete_input_url: BuilderStorage.get('siteEmulated'),
        biz_type: BuilderStorage.get('industry'),
        biz_desc: BuilderStorage.get('description'),
        select_topics: BuilderStorage.get('selectedTopics').join(','),
        non_select_topics: (BuilderStorage.get('topics') || []).filter(topic => !selectedTopics.includes(topic)).join(','),
        word_length: BuilderStorage.get('desiredLength'),
        url_language: BuilderStorage.get('preferredLanguage')
      });
    },
    trackBizDescConfirm: function () {
      window.dataLayer.push({
        event: "Biz_Desc_Confirm",
        session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
        click_id: "NA",
        compete_input_url: BuilderStorage.get('siteEmulated'),
        biz_type: BuilderStorage.get('industry'),
        ai_biz_desc: BuilderStorage.get('description'),
        biz_desc: BuilderStorage.get('description')
      });
    },
    trackBizTopicsSelected: function (selectedTopics) {
      window.dataLayer.push({
        event: "Biz_Topics_Selected",
        session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
        click_id: "NA",
        compete_input_url: BuilderStorage.get('siteEmulated'),
        biz_type: BuilderStorage.get('industry'),
        ai_biz_desc: BuilderStorage.get('description'),
        biz_desc: BuilderStorage.get('description'),
        select_topics: selectedTopics.join(','),
        non_select_topics: (BuilderStorage.get('topics') || []).filter(topic => !selectedTopics.includes(topic)).join(',')
      });
    },
    trackAIBizSelected: function (description) {
      window.dataLayer.push({
        event: "AI_Biz_Selected",
        session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
        click_id: "NA",
        compete_input_url: BuilderStorage.get('siteEmulated'),
        biz_type: BuilderStorage.get('industry'),
        ai_biz_desc: description
      });
    },
    trackNameOBCPop: function () {
      const sessionId = JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '';
      const siteUrl = BuilderStorage.get('siteEmulated') || 'NA';
      const bizType = BuilderStorage.get('industry') || 'NA';
      const bizDesc = BuilderStorage.get('description') || 'NA';
      const selectedTopics = BuilderStorage.get('selectedTopics') || [];
      const allTopics = BuilderStorage.get('topics') || [];

      const nonSelectedTopics = allTopics.filter(topic => !selectedTopics.includes(topic));

      window.dataLayer.push({
        event: "name_obc_pop",
        session_id: sessionId,
        click_id: "NA",
        compete_input_url: siteUrl,
        biz_type: bizType,
        ai_biz_desc: bizDesc,
        biz_desc: bizDesc,
        select_topics: selectedTopics.join(','),
        non_select_topics: nonSelectedTopics.join(','),
        offer_partner: craftrtech_ajax?.ppc_domain_builder?.redirect_url || 'https://www.namecheap.com'
      });
    },
    trackErrorOnCompeteBtn: function (urlInput, errorMessage) {
      window.dataLayer.push({
        event: "Error_on_Compete_btn_click",
        session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
        compete_input_url: urlInput,
        click_id: "NA",
        error_message: errorMessage
      });
    },
    trackCompeteBtnClick: function (urlInput) {
      window.dataLayer.push({
        event: "Compete_btn_click",
        session_id: JSON.parse(localStorage.getItem('ad_parameters'))?.gclid || '',
        click_id: "NA",
        compete_input_url: urlInput
      });
    }
  };

  // Add the event listener using event delegation
  $(document).on('click', 'a.outbound-link', function (e) {
    // Get the outbound URL
    const outboundUrl = $(this).attr('href');
    const domainIndex = $(this).data('domain-index');
    const domain = $(this).text().trim();
    const domainOuterIndex = $(this).closest('.card-body').data('domain-outer-index');

    // Track the click
    AnalyticsHelper.trackOutboundClick(outboundUrl, domainIndex, domainOuterIndex, domain);

    // Don't prevent default - let the link work normally
  });

  // Add this helper function at the top level
  const sanitizeInput = input => (input = input?.replace(/[&\/\\#+=!%`_$~%.'":;*?<>{}]/g, ""))?.replace(/\s+/g, " ").trim() || "";

  const setPopunderCookie = () => {
    const expiry = new Date();
    expiry.setTime(expiry.getTime() + 600000); // 10 minutes expiry
    document.cookie = `popunder_shown=yes; expires=${expiry.toUTCString()}; path=/`;
  };

  const hasPopunderCookie = () => {
    return document.cookie.includes('popunder_shown=yes');
  };
});